import { NEONVERSE } from '../constants';

const NeonFooter = () => (
  <footer className="nv-footer">
    <div className="nv-container">
      <p className="nv-footer__brand">
        Neon <span>Verse</span> Studio
      </p>
      <p>Premium Personalized Music Crafted From Your Story.</p>
      <p>{NEONVERSE.tagline}</p>
      <p className="nv-footer__location">{NEONVERSE.location}</p>
      <p className="nv-footer__copy">© Neon Verse Studio</p>
    </div>
  </footer>
);

export default NeonFooter;
